"use client";

import { useTranslations } from "next-intl";
import { Box, Typography } from "@/components/controls/base-controls";
import FlightReqForm from "@/components/forms/flight-req.form";
import { WEBPAGE_CORE_CONTAINER } from "@/core/constants/webpages";

const FormWrapper = () => {
	const t = useTranslations();

    return (
		<Box
			sx={{
				backgroundColor: "var(--mui-palette-page-bg)",
				display: "grid",
				gridTemplateColumns: { xs: "1fr", md: "1fr 1.5fr" },
				gap: 2,
				margin: "0 auto",
				padding: { xs: "1em 1em 2em", md: "3em 1em 2.5em" },
				width: WEBPAGE_CORE_CONTAINER,
				maxWidth: "100%",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: {xs: 'flex-start', md: 'center'},
					justifyContent: "flex-start"
				}}
			>
				<Typography
					variant="body1"
					component="div"
					sx={{
						color: "var(--mui-palette-darkest)",
						width: { xs: "100%", md: "30em" },
						maxWidth: "100%",
					}}
				>
					{t.rich("flightReq.feature.text", {
						p: (chunks) => <p>{chunks}</p>
					})}
				</Typography>
			</Box>

			<FlightReqForm />
			
		</Box>
    );
};

export default FormWrapper;
